/**
 * Filtering Prompts Tutorial
 * Guides users through using the filter options to find prompts.
 * Written for older, less tech-savvy users with simple language.
 *
 * Content tone:
 * - requiresClick steps use direct instructions ("Tap this to...")
 * - Informational steps use descriptive language ("You can use this to...")
 */

export const filteringPromptsTutorial = {
  id: 'filtering-prompts',
  name: 'How to Filter Prompts',
  description: 'Learn how to find the prompts you are looking for',

  steps: [
    {
      id: 'open-filter',
      selector: '.filter-toggle-button',
      title: 'Open the Filter',
      content: 'Tap this button to open the filter options.',
      position: 'left',
      highlightPadding: 8,
      requiresClick: true
    },
    {
      id: 'intro-filter-box',
      selector: '.filter-box',
      title: 'The Filter Area',
      content: 'This is where you can filter and search for prompts. Let me show you each option.',
      position: 'right',
      highlightPadding: 8,
      waitForElement: true,
      maxWaitTime: 3000,
      disableTargetClick: true
    },
    {
      id: 'hide-shared-toggle',
      selector: '.filter-box .toggle-switch',
      title: 'Hide Shared',
      content: 'This toggle can be used to hide prompts that others have shared with you. Turn it off to see everything.',
      position: 'right',
      highlightPadding: 8,
      waitForElement: true,
      maxWaitTime: 3000,
      disableTargetClick: true
    },
    {
      id: 'search-box',
      selector: '.filter-box .filter-search-input',
      title: 'Search Box',
      content: 'You can type here to search for specific words. It looks through prompt titles, your reflections, and usernames.',
      position: 'right',
      highlightPadding: 4,
      waitForElement: true,
      maxWaitTime: 3000,
      disableTargetClick: true
    },
    {
      id: 'show-dropdown',
      selector: '.filter-box .filter-column:first-child .filter-dropdown',
      title: 'Show Filter',
      content: 'This dropdown lets you choose what prompts to show. "Show All" shows everything. "Unanswered Only" shows prompts you have not answered yet. "Answered Only" shows prompts you have already answered. "New Only" shows prompts you have not seen before.',
      position: 'right',
      highlightPadding: 4,
      waitForElement: true,
      maxWaitTime: 3000,
      disableTargetClick: true
    },
    {
      id: 'date-filter-dropdown',
      selector: '.filter-box .filter-column:last-child .filter-dropdown',
      title: 'Date Filter',
      content: 'This dropdown can be used to filter prompts by when they were created or last updated. You can show prompts from the last week, last month, or pick your own dates.',
      position: 'left',
      highlightPadding: 4,
      waitForElement: true,
      maxWaitTime: 3000,
      disableTargetClick: true
    },
    {
      id: 'help-button',
      selector: '.help-btn',
      title: 'More Tutorials',
      content: 'Tap the "?" button any time to find more tutorials and learn about other features.',
      position: 'bottom',
      highlightPadding: 4
    },
    {
      id: 'complete',
      selector: null,
      title: 'Now You Know!',
      content: 'You can use these filters to find exactly what you are looking for. Try them out!',
      position: 'center',
      isCompletionStep: true
    }
  ]
};
